var _style, _rect, _polygon, _polygon2, _circle, _rect2, _polygon3, _polygon4, _circle2, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _polygon5, _path26, _polygon6, _path27, _path28, _circle3, _path29, _path30, _path31, _path32, _path33;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgOffer(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Calque_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 601.6 630",
    style: {
      enableBackground: "new 0 0 601.6 630"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#E6E6E6;}\n\t.st1{fill:#3F3D56;}\n\t.st2{fill:#99D022;}\n\t.st3{fill:#CCCCCC;}\n\t.st4{fill:#FF6584;}\n\t.st5{fill:#A0616A;}\n\t.st6{fill:#2F2E41;}\n")), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 457.8,
    y: 60.5,
    transform: "matrix(0.6895 -0.7243 0.7243 0.6895 59.0145 367.8781)",
    className: "st0",
    width: 1.7,
    height: 109.2
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "498.8,144 497.2,144.1 497.7,152.3 489.4,152.2 489.4,153.9 499.5,154 "
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "427.8,76.3 427.8,78 419.5,77.9 420,86.1 418.4,86.2 417.7,76.2 "
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 458.6,
    cy: 115.1,
    r: 9.2
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 90.1,
    y: 114.3,
    transform: "matrix(0.7243 -0.6895 0.6895 0.7243 -39.4758 131.496)",
    className: "st0",
    width: 109.2,
    height: 1.7
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "103.8,154 113.9,153.9 113.8,152.2 105.6,152.3 106.1,144.1 104.4,144 "
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "185.5,76.2 184.9,86.2 183.2,86.1 183.7,77.9 175.5,78 175.5,76.3 "
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 144.7,
    cy: 115.1,
    r: 9.2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M370.2,190.5H231.4c-4.2,0-7.5-3.4-7.5-7.5V7.5c0-4.2,3.4-7.5,7.5-7.5h138.7c4.2,0,7.5,3.4,7.5,7.5V183 C377.7,187.2,374.3,190.5,370.2,190.5z M231.4,1.7c-3.2,0-5.8,2.6-5.8,5.9V183c0,3.2,2.6,5.8,5.8,5.9h138.7c3.2,0,5.8-2.6,5.8-5.9 V7.5c0-3.2-2.6-5.8-5.8-5.9L231.4,1.7z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M289.3,84.4h-30.5c-2.1,0-3.8-1.7-3.8-3.8v-36c0-2.1,1.7-3.8,3.8-3.8h30.5c2.1,0,3.8,1.7,3.8,3.8v36 C293,82.7,291.3,84.4,289.3,84.4z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M348.6,101.1h-30.5c-2.1,0-3.8-1.7-3.8-3.8v-36c0-2.1,1.7-3.8,3.8-3.8h30.5c2.1,0,3.8,1.7,3.8,3.8v36 C352.4,99.4,350.7,101.1,348.6,101.1z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M301,152.1h-30.5c-2.1,0-3.8-1.7-3.8-3.8v-36c0-2.1,1.7-3.8,3.8-3.8H301c2.1,0,3.8,1.7,3.8,3.8v36 C304.7,150.4,303,152,301,152.1z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M594.1,371H455.3c-4.2,0-7.5-3.4-7.5-7.5V188c0-4.2,3.4-7.5,7.5-7.5h138.7c4.2,0,7.5,3.4,7.5,7.5v175.5 C601.6,367.6,598.2,371,594.1,371z M455.3,182.1c-3.2,0-5.8,2.6-5.8,5.9v175.5c0,3.2,2.6,5.8,5.8,5.9h138.7c3.2,0,5.8-2.6,5.8-5.9 V188c0-3.2-2.6-5.8-5.8-5.9H455.3z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M548.5,219.3h-47.6c-1.8,0-3.3-1.5-3.3-3.3s1.5-3.3,3.3-3.3l0,0h47.6c1.8,0,3.3,1.5,3.3,3.3 S550.4,219.3,548.5,219.3L548.5,219.3z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M571.9,251.1h-94.4c-1.8,0-3.3-1.5-3.4-3.3c0-1.8,1.5-3.3,3.3-3.4c0,0,0,0,0,0h94.4c1.8,0,3.3,1.5,3.4,3.3 C575.3,249.6,573.8,251.1,571.9,251.1C571.9,251.1,571.9,251.1,571.9,251.1z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M571.9,268.6h-94.4c-1.8,0-3.3-1.5-3.4-3.3c0-1.8,1.5-3.3,3.3-3.4c0,0,0,0,0,0h94.4c1.8,0,3.3,1.5,3.4,3.3 C575.3,267.1,573.8,268.6,571.9,268.6C571.9,268.6,571.9,268.6,571.9,268.6z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M571.9,286.2h-94.4c-1.8,0-3.3-1.5-3.4-3.3c0-1.8,1.5-3.3,3.3-3.4c0,0,0,0,0,0h94.4c1.8,0,3.3,1.5,3.4,3.3 C575.3,284.7,573.8,286.2,571.9,286.2C571.9,286.2,571.9,286.2,571.9,286.2z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M571.9,303.7h-94.4c-1.8,0-3.3-1.5-3.4-3.3c0-1.8,1.5-3.3,3.3-3.4c0,0,0,0,0,0h94.4c1.8,0,3.3,1.5,3.4,3.3 C575.3,302.2,573.8,303.7,571.9,303.7C571.9,303.7,571.9,303.7,571.9,303.7z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M571.9,321.3h-94.4c-1.8,0-3.3-1.5-3.4-3.3c0-1.8,1.5-3.3,3.3-3.4c0,0,0,0,0,0h94.4c1.8,0,3.3,1.5,3.4,3.3 C575.3,319.8,573.8,321.3,571.9,321.3C571.9,321.3,571.9,321.3,571.9,321.3z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M571.9,338.8h-94.4c-1.8,0-3.3-1.5-3.4-3.3c0-1.8,1.5-3.3,3.3-3.4c0,0,0,0,0,0h94.4c1.8,0,3.3,1.5,3.4,3.3 C575.3,337.3,573.8,338.8,571.9,338.8C571.9,338.8,571.9,338.8,571.9,338.8z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M146.2,371H7.5c-4.2,0-7.5-3.4-7.5-7.5V188c0-4.2,3.4-7.5,7.5-7.5h138.7c4.2,0,7.5,3.4,7.5,7.5v175.5 C153.8,367.6,150.4,371,146.2,371z M7.5,182.1c-3.2,0-5.8,2.6-5.9,5.9v175.5c0,3.2,2.6,5.8,5.9,5.9h138.7c3.2,0,5.8-2.6,5.9-5.9V188 c0-3.2-2.6-5.8-5.9-5.9H7.5z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M124.2,221.9H82.5c-1.8,0-3.3-1.5-3.3-3.3s1.5-3.3,3.3-3.3h41.8c1.8,0,3.3,1.5,3.3,3.3S126.1,221.9,124.2,221.9 z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M124.2,239.4H82.5c-1.8,0-3.3-1.5-3.3-3.3s1.5-3.3,3.3-3.3h41.8c1.8,0,3.3,1.5,3.3,3.3S126.1,239.4,124.2,239.4 z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M61,249.4H30.5c-2.1,0-3.8-1.7-3.8-3.8v-36c0-2.1,1.7-3.8,3.8-3.8H61c2.1,0,3.8,1.7,3.8,3.8v36 C64.8,247.8,63.1,249.4,61,249.4z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M124,275.4H29.5c-1.8,0-3.3-1.5-3.4-3.3c0-1.8,1.5-3.3,3.3-3.4c0,0,0,0,0,0H124c1.8,0,3.3,1.5,3.4,3.3 C127.3,273.9,125.8,275.4,124,275.4C124,275.4,124,275.4,124,275.4z"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M124,292.9H29.5c-1.8,0-3.3-1.5-3.4-3.3c0-1.8,1.5-3.3,3.3-3.4c0,0,0,0,0,0H124c1.8,0,3.3,1.5,3.4,3.3 C127.3,291.4,125.8,292.9,124,292.9C124,292.9,124,292.9,124,292.9z"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M124,310.5H29.5c-1.8,0-3.3-1.5-3.4-3.3c0-1.8,1.5-3.3,3.3-3.4c0,0,0,0,0,0H124c1.8,0,3.3,1.5,3.4,3.3 C127.3,309,125.8,310.5,124,310.5C124,310.5,124,310.5,124,310.5z"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M124,328H29.5c-1.8,0-3.3-1.5-3.4-3.3c0-1.8,1.5-3.3,3.3-3.4c0,0,0,0,0,0H124c1.8,0,3.3,1.5,3.4,3.3 C127.3,326.5,125.8,328,124,328C124,328,124,328,124,328z"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M124,345.6H29.5c-1.8,0-3.3-1.5-3.4-3.3c0-1.8,1.5-3.3,3.3-3.4c0,0,0,0,0,0H124c1.8,0,3.3,1.5,3.4,3.3 C127.3,344.1,125.8,345.6,124,345.6C124,345.6,124,345.6,124,345.6z"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M198.7,472.7v-36c0-2.1,1.7-3.8,3.8-3.8H233c2.1,0,3.8,1.7,3.8,3.8v36c0,2.1-1.7,3.8-3.8,3.8h-30.5 C200.4,476.5,198.7,474.8,198.7,472.7z"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M209.7,460.7v-36c0-2.1,1.7-3.8,3.8-3.8H244c2.1,0,3.8,1.7,3.8,3.8v36c0,2.1-1.7,3.8-3.8,3.8h-30.5 C211.4,464.5,209.7,462.8,209.7,460.7z"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M346.6,449.2c-4.3-2.5-5.8-8.1-3.3-12.4c0.3-0.5,0.6-0.9,0.9-1.3l-9.5-69.2l19.7,1l3.1,67.5 c3.6,3.5,3.7,9.3,0.2,12.9C354.8,450.7,350.2,451.3,346.6,449.2L346.6,449.2z"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M357.1,368.2c-0.4,0.5-0.9,0.8-1.5,1.1l-17.7,6.8c-1.8,0.7-3.9-0.2-4.7-2l-15.7-35.3c-1.5-3.3-1.8-7-0.7-10.4 c1.6-5,5.8-8.8,10.9-9.8c1.9-0.4,4-0.4,5.9,0.1c4.7,1,8.6,4.4,10.3,8.9l14,36.9C358.3,365.7,358,367.1,357.1,368.2z"
  })), _polygon5 || (_polygon5 = /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "264.8,618.1 252.5,618.1 248.1,570.5 264.8,570.8 "
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M243.8,614.6h23.6l0,0v14.9l0,0h-38.5l0,0l0,0C228.9,621.2,235.6,614.6,243.8,614.6z"
  })), _polygon6 || (_polygon6 = /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "321.8,618.1 309.5,618.1 303.7,570.8 321.8,570.8 "
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M300.8,614.6h23.6l0,0v14.9l0,0h-38.5l0,0l0,0C285.9,621.2,292.6,614.6,300.8,614.6z"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M323.3,601.2l-19.3-1.4c-2.3-0.2-4.1-2-4.2-4.3l-4.3-88.7c-0.1-1.9-1.7-3.4-3.7-3.3c-1.6,0.1-2.9,1.2-3.3,2.8 l-17.9,87.4c-0.5,2.2-2.5,3.8-4.8,3.6l-17.4-1.4c-2.5-0.2-4.3-2.4-4.1-4.8c0,0,0-0.1,0-0.1l16.1-161.5c0.2-2.5,2.5-4.3,4.9-4 c0.2,0,0.3,0,0.5,0.1l61.4,13.3c2.1,0.5,3.6,2.3,3.5,4.5l-2.9,153.5c0,2.4-2,4.4-4.5,4.4C323.6,601.2,323.5,601.2,323.3,601.2z"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    className: "st5",
    cx: 306.5,
    cy: 269.9,
    r: 24.6
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M268.4,441.9c-4.8-4.3-7.4-10.4-7.3-16.9c0-35.3,30.6-114.2,31.5-116.6c0.1-0.6,0.9-0.8,5.1-3.7 c4.2-2.9,10.3-3.3,18.1-1.3c1.6,0.4,2.9,1.7,3.2,3.3l1.5,2.1c0.3,1.1,1,2,2,2.4c6.3,2.7,26.3,14.9,19.5,60.9 c-6.3,42.7-8.9,67.9-9.7,76.7c-0.2,2.2-1.9,3.9-4.1,4.1c-3.1,0.3-8.4,0.6-14.7,0.6C299,453.5,278.9,451.6,268.4,441.9z"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M239,428.8c-2.2-4.5-0.3-9.9,4.2-12.1c0.5-0.2,1-0.4,1.5-0.6l30.7-62.7l15.8,11.8l-35,57.8 c1.1,4.9-2.1,9.8-7,10.9C245.1,434.7,240.9,432.6,239,428.8L239,428.8z"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M293,367.5c-0.6,0.2-1.2,0.2-1.8,0l-18.5-4.3c-1.9-0.4-3.2-2.3-2.8-4.3l6.6-38c0.6-3.6,2.4-6.8,5.2-9.1 c4.1-3.3,9.7-4.1,14.5-2c1.8,0.8,3.5,1.9,4.8,3.4c3.3,3.5,4.7,8.4,3.6,13.1l-9,38.4C295.3,366,294.3,367.1,293,367.5z"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M300.8,292.1c-2.4-2.5-3.5-6-2.8-9.4c0.9-4.5,1.4-7.4,1.5-8.5l0,0c0.3-3.6-3.4-6.6-7-7.1c-0.1,0-0.3,0-0.4,0 c0.1,0.1,0.2,0.2,0.3,0.3c0.7,0.7,1.6,1.5,1.4,2.3c-0.1,0.5-0.6,0.9-1.4,1.1c-5.7,1.6-10.1,0.1-13.8-4.6c-1-1.3-1.8-2.9-2.1-4.6 c-1.3-6.6,2.2-12.1,5.4-15.7c2.7-2.9,7-6.4,12.4-6.8c4.2-0.2,9.2,2.2,10.7,6.6c1.4-2.1,3.8-3.5,6.4-3.6c2.9-0.1,5.7,0.7,8.2,2.3 c11.9,6.8,17,23.1,11.2,35.5c-3.7,7.8-11.7,13.6-20.8,15.2c-0.6,0.1-1.2,0.1-1.7,0.1C305.3,295.2,302.7,294.1,300.8,292.1z"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M185.6,630h195c0.6,0,1-0.4,1-1s-0.4-1-1-1h-195c-0.6,0-1,0.4-1,1S185,630,185.6,630z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOffer);
export default __webpack_public_path__ + "static/media/offer.8915e42bcdde76f89eba93a6d7884963.svg";
export { ForwardRef as ReactComponent };